/**
 * Created by karthikeyan.k on 04-04-2022.
 */
export class SpriteConstant {
  public static get COMMON_ICONS(): any {
    return {
      spriteContainerName: 'common_icons',
      spriteName: 'common_icons_sprite_img',
      spriteJSONName: 'common_icons_sprite_json',
      basePath: 'assets/images/lobby_sprite_images/common/lobby_icons/common',
    };
  }

  public static get MOBILE_ICONS(): any {
    return {
      spriteContainerName: 'mobile_icons',
      spriteName: 'mobile_icons_sprite_img',
      spriteJSONName: 'mobile_icons_sprite_json',
      basePath: 'assets/images/lobby_sprite_images/common/lobby_icons/mobile',
    };
  }

  public static LANG_ICONS(language = 'en'): any {
    return {
      spriteContainerName: 'lang',
      spriteName: 'lang_sprite_img',
      spriteJSONName: 'lang_sprite_json',
      basePath:
        'assets/images/lobby_sprite_images/lang_sprite_images/' +
        language +
        '_fcg',
    };
  }

  public static get FC21_ICONS(): any {
    return {
      spriteContainerName: 'fc21_icons',
      spriteName: 'fc21_icon_sprite_img',
      spriteJSONName: 'fc21_icon_sprite_json',
      basePath: 'assets/images/lobby_sprite_images/common/lobby_icons/fc21',
    };
  }

  public static get FCB_ICONS(): any {
    return {
      spriteContainerName: 'fcb_icons',
      spriteName: 'fcb_icon_sprite_img',
      spriteJSONName: 'fcb_icon_sprite_json',
      basePath: 'assets/images/lobby_sprite_images/common/lobby_icons/fcb',
    };
  }

  public static get MENU_ICONS(): any {
    return {
      spriteContainerName: 'lobby',
      spriteName: 'menu_sprite_img',
      spriteJSONName: 'menu_sprite_json',
      basePath: 'assets/images/lobby_sprite_images/common/menu_sprite_images/',
    };
  }

  public static LOBBY_BG_DESKTOP(gameName = 'fc21'): any {
    return {
      spriteContainerName: 'lobby_bg',
      spriteName: 'bg_' + gameName + '_desktop_sprite_img',
      spriteJSONName: 'bg_' + gameName + '_desktop_sprite_json',
      basePath:
        'assets/images/lobby_sprite_images/allgames/bg_' +
        gameName +
        '_desktop',
    };
  }

  public static LOBBY_BG_MOBILE(gameName = 'fc21'): any {
    return {
      spriteContainerName: 'lobby_bg',
      spriteName: 'bg_' + gameName + '_mobile_sprite_img',
      spriteJSONName: 'bg_' + gameName + '_mobile_sprite_json',
      basePath:
        'assets/images/lobby_sprite_images/allgames/bg_' + gameName + '_mobile',
    };
  }

  public static TILE_OVERLAY(gameName = 'fc21', language = 'en'): any {
    return {
      spriteContainerName: 'tile_overlay_both',
      spriteName: 'tile_' + gameName + '_both_sprite_img',
      spriteJSONName: 'tile_' + gameName + '_both_sprite_json',
      basePath:
        'assets/images/lobby_sprite_images/allgames/tile_' +
        gameName +
        '_both/' +
        language +
        '_fcg',
    };
  }

  public static TILE_BG(gameName = 'fc21'): any {
    return {
      spriteContainerName: 'tile_bg_' + gameName,
      spriteName: 'tile_bg_icon_' + gameName + '_sprite_img',
      spriteJSONName: 'tile_bg_icon_' + gameName + '_sprite_json',
      basePath:
        'assets/images/lobby_sprite_images/common/tile_bg/tile_bg_' + gameName,
    };
  }

  public static get CARD(): any {
    return {
      spriteContainerName: 'cards',
      spriteName: 'cards_sprite_img',
      spriteJSONName: 'cards_sprite_json',
      basePath: 'assets/images/game_spritesheets/common',
    };
  }

  public static get CHIP(): any {
    return {
      spriteContainerName: 'chips',
      spriteName: 'chips_sprite_img',
      spriteJSONName: 'chips_sprite_json',
      basePath: 'assets/images/game_spritesheets/common',
    };
  }

  public static get BUTTON_BLANK(): any {
    return {
      spriteContainerName: 'buttonblank',
      spriteName: 'button_sprite_img',
      spriteJSONName: 'button_sprite_json',
      basePath: 'assets/images/game_spritesheets/common',
    };
  }

  public static BUTTON_OVERLAY(language): any {
    return {
      spriteContainerName: 'langbutton',
      spriteName: 'lang_button_sprite_img',
      spriteJSONName: 'lang_button_sprite_json',
      basePath: 'assets/images/game_spritesheets/' + language,
    };
  }

  public static get HISTORY_ICONS(): any {
    return {
      spriteContainerName: 'history_icons',
      spriteName: 'history_icons_sprite_img',
      spriteJSONName: 'history_icons_sprite_json',
      basePath: 'assets/images/game_spritesheets/common',
    };
  }

  public static get HISTORY_CARDS(): any {
    return {
      spriteContainerName: 'history_cards',
      spriteName: 'history_cards_sprite_img',
      spriteJSONName: 'history_cards_sprite_json',
      basePath: 'assets/images/game_spritesheets/common',
    };
  }

  public static SELECT_TABLE_TILE_OVERLAY(
    gameName = 'fc21',
    language = 'en'
  ): any {
    return {
      spriteContainerName: 'select_table_tile_overlay',
      spriteName: 'select_table_tile_' + gameName + '_sprite_img',
      spriteJSONName: 'select_table_tile_' + gameName + '_sprite_json',
      basePath:
        'assets/images/lobby_sprite_images/selecttable/tile_' +
        gameName +
        '_both/' +
        language +
        '_fcg',
    };
  }
}
